import { MenuItem } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import dayjs from 'dayjs';
import Localization from 'l18n/l18n';
import React, {useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import iraqCities from '../../assets/data/iraqCities.json';
import ScheduleAppointment from './schedule_appointment';

export default function Popup(props){
    const { openPopup, setOpenPopup} = props;
    const [openScheduleAppointment, setOpenScheduleAppointment] = useState(false);
    const { handleSubmit, control } = useForm({defaultValues:{
      birthdate:dayjs().format('YYYY-MM-DD')
    }});
    const onSubmit = (data) =>console.log(data) ;
    const handleClose = () => {
        setOpenPopup(false);
      };
  
    return(
      <Dialog open={openPopup} onClose={handleClose}>
      <DialogTitle sx={{ m: 0, p: 2 , backgroundColor:'#CBE7FF', fontWeight:'bold'}}>
      {Localization.translate['add_new_patient']}
    </DialogTitle>
      <DialogContent dividers>
      <Typography sx={{ mt: 2, ml:1, fontWeight:'bold' }}>  {Localization.translate['patient_name']} </Typography>
      <form>
		<Grid container spacing={2}>
		<Grid item xs={12} md={3.5} sx={{mr:1}}>

    <Controller
                    name={'first_name'}
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField onChange={onChange} value={value} 
                margin="normal"
                fullWidth
                name="first_name"
                label={Localization.translate['first_name']}
                type="text"
                id="first_name"
                autoComplete="first_name"
             />
                    )}
                  />
          
        </Grid>
        <Grid item xs={12} md={3.5} sx={{mr:1}}>
        <Controller
                    name={'second_name'}
                    control={control}
                    render={({ field: { onChange, value } }) => (
                    <TextField onChange={onChange} value={value} 
                margin="normal"
                fullWidth
                name="father_name"
                label={Localization.translate['father_name']}
                type="text"
                id="father_name"
                autoComplete="father_name"
             />
                    )}
                  />
	
        </Grid>
		<Grid item xs={12} md={3.5}>
    <Controller
                    name={'last_name'}
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField onChange={onChange} value={value} 
                      margin="normal"
                      fullWidth
                      name="last_name"
                      label={Localization.translate['last_name']}
                      type="text"
                      id="last_name"
                      autoComplete="last_name"
                   />
                    )}
                  />
	
        </Grid>
		</Grid>
		
		<Grid container >
		<Typography sx={{ mt: 2, ml:1, fontWeight:'bold' }}>  {Localization.translate['phone_number']} </Typography>
    <Controller
                    name={'phone_number'}
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField onChange={onChange} value={value} 
                      margin="normal"
                      fullWidth
                      name="phone_number"
                      label={Localization.translate['phone_number']}
                      type="phone"
                      id="phone_number"
                      autoComplete="phone_number"
                  />
                    )}
                  />
		
		</Grid>

		<Grid container >
		<Typography sx={{ mt: 2, ml:1, fontWeight:'bold' }}>  {Localization.translate['birthdate']} </Typography>
    <Controller
                    name={'birthdate'}
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField onChange={onChange} value={value} 
                      margin="normal"
                      fullWidth
                      name="birthdate"
                      type="date"
                      id="birthdate"
                      autoComplete="birthdate"
                  />
                    )}
                  />
		
		</Grid>
		<Typography sx={{ mt: 2, ml:1, fontWeight:'bold' }}>  {Localization.translate['address']} </Typography>
		<Grid container >
        <Grid item xs={12} md={3.5} sx={{mr:1}}>
        <Controller
                    name={'city'}
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField onChange={onChange} value={value} 
                select
                margin="normal"
                fullWidth
                name="city"
                label={Localization.translate['city']}
                type="text"
                id="city"
                autoComplete="city"
             >
              {iraqCities.map(city =><MenuItem  key={city.iso_code} value={city.name_ar}>{city.name_ar}</MenuItem>)}
             </TextField>
                    )}
                  />
          
        </Grid>
        <Grid item xs={12} md={3.5} sx={{mr:1}}>
        <Controller
                    name={'area'}
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField onChange={onChange} value={value} 
                      select
                      margin="normal"
                      fullWidth
                      name="area"
                      label={Localization.translate['area']}
                      type="text"
                      id="area"
                      autoComplete="area"
                   >
                      {iraqCities.map(city =><MenuItem  key={city.iso_code} value={city.name_ar}>{city.name_ar}</MenuItem>)}
                   </TextField>
                    )}
                  />
	
        </Grid>
        <Grid item xs={12} md={3.5}>

             <Controller
                    name={'point_of_interest'}
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField onChange={onChange} value={value} 
                      margin="normal"
                      fullWidth
                      name="point_of_interest"
                      label={Localization.translate['point_of_interest']}
                      type="text"
                      id="point_of_interest"
                      autoComplete="point_of_interest"
                   />
                    )}
                  />
	
        </Grid>

		</Grid>
    </form>
      </DialogContent>
      <DialogActions>
              <Button 
              variant="contained" 
              fullWidth
              sx={{color:'#FFFFFF'}} 
              onClick={handleSubmit(onSubmit)}>
                {Localization.translate['save_to_patient_file']}
                </Button>
              <Button 
              variant="outlined" 
              fullWidth
              onClick={()=>setOpenScheduleAppointment(true)}>
                {Localization.translate['submit_with_booking_appointment']}
                </Button>
            </DialogActions>
            <ScheduleAppointment
            openScheduleAppointment = {openScheduleAppointment}
            setOpenScheduleAppointment = {setOpenScheduleAppointment} >
            </ScheduleAppointment>
      </Dialog>
    );
    }
